import { World, Level } from '../types/world';
import { GameData } from '../types/game';

export function validateWorld(world: any): world is World {
  if (!world || typeof world !== 'object') return false;
  if (!world.id || !world.name || !world.description) return false;
  if (typeof world.order !== 'number') return false;
  if (!Array.isArray(world.levels)) return false;
  
  return world.levels.every((level: any) => validateLevel(level));
}

export function validateLevel(level: any): level is Level {
  if (!level || typeof level !== 'object') return false;
  if (!level.id || !level.name || !level.description) return false;
  if (!level.objective || !level.startingCode) return false;
  // solution is optional - stored separately in /sols
  if (!Array.isArray(level.hints) || level.hints.length !== 3) return false;
  if (typeof level.difficulty !== 'number' || level.difficulty < 1 || level.difficulty > 5) return false;
  if (level.allowAllTactics !== undefined && typeof level.allowAllTactics !== 'boolean') return false;
  for (const field of ['allowedTactics', 'forbiddenTheorems']) {
    if (field === 'allowedTactics' && level[field] === 'all') continue;
    if (level[field] !== undefined && (!Array.isArray(level[field]) || !level[field].every((name: unknown) => typeof name === 'string' && name.length > 0))) return false;
  }
  if (level.availableTheorems !== undefined && (!Array.isArray(level.availableTheorems) || !level.availableTheorems.every((reference: any) =>
    reference && ['name', 'statement', 'description', 'example'].every(field => typeof reference[field] === 'string' && reference[field].length > 0) &&
    (reference.unlockedBy === undefined || typeof reference.unlockedBy === 'string')))) return false;
  
  return true;
}

export function validateGameData(data: any): data is GameData {
  if (!data || typeof data !== 'object') return false;
  if (!data.version || !data.user || !data.progress) return false;
  if (!data.proofs || !data.unlockedTactics || !data.achievements || !data.settings) return false;
  
  return true;
}
